export const getters = {
  getEvents: (state, id) => (state.modelSet && state.modelSet[id] ? state.modelSet[id].events : []),
  getFromDate: (state, id) => (state.modelSet[id] ? state.modelSet[id].fromDate : null),
  getToDate: (state, id) => (state.modelSet[id] ? state.modelSet[id].toDate : null),
};
